import React, {PureComponent} from 'react';
import styles from './Tabs.module.scss';
import PropTypes from "prop-types";
import TabTitle from "./Tab/TabTitle";

class Tabs extends PureComponent {

    state = {
        activeTab: null
    };

    setActiveTab = activeTab => {
        this.setState({activeTab});
    };

    renderTabs = () => {
        const {children} = this.props;
        const {activeTab} = this.state;

        if (!children) {
            return null;
        }

        let activeTabJsx = null;
        const titles = children.map((tab, idx) => {
            const isSelected = ((activeTab === tab.props.id) || (activeTab === null && tab.props.isDefault));
            const isDisabled = tab.props.disabled;
            const isShy = tab.props.shy;

            if (isSelected) {
                activeTabJsx = tab.props.children;
            }

            return (
                <TabTitle selected={isSelected}
                          disabled={isDisabled}
                          shy={isShy}
                          key={idx}
                          clickHandler={() => this.setActiveTab(tab.props.id)}>
                    {tab.props.title}
                </TabTitle>
            );
        });

        return (
            <div className={styles.tabsContainer}>
                <div className={styles.tabsTitlesContainer} id={'search-widget-tabs-header-opts'}>
                    {titles}
                </div>
                <div className={styles.activeTabContainer}>
                    {activeTabJsx}
                </div>
            </div>
        );
    };

    render() {
        return this.renderTabs();
    }
}

Tabs.propTypes = {
    children: PropTypes.any,
};

Tabs.defaultProps = {
    children: null
};

export default Tabs;
